/**
 * Auth session helpers – remember-me preference and JWT TTL alignment.
 */

export const REMEMBER_ME_KEY = "auth_remember_me";

export function setRememberMePreference(rememberMe: boolean): void {
  if (typeof window === "undefined") return;
  if (rememberMe) {
    localStorage.setItem(REMEMBER_ME_KEY, "1");
  } else {
    localStorage.removeItem(REMEMBER_ME_KEY);
  }
}

export function clearRememberMePreference(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(REMEMBER_ME_KEY);
}

export function isRememberMeSession(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem(REMEMBER_ME_KEY) === "1";
}

/** Derive storage TTL from JWT exp so client expiry matches server. */
export function ttlFromJwt(token: string, fallbackSeconds: number): number {
  try {
    const payload = JSON.parse(atob(token.split(".")[1] || ""));
    if (typeof payload.exp === "number") {
      return Math.max(60, payload.exp - Math.floor(Date.now() / 1000));
    }
  } catch {
    // Ignore malformed tokens
  }
  return fallbackSeconds;
}

export const ACCESS_TOKEN_TTL_DEFAULT = 15 * 60;
export const ACCESS_TOKEN_TTL_REMEMBER = 24 * 60 * 60;
export const REFRESH_TOKEN_TTL_DEFAULT = 7 * 24 * 60 * 60;
export const REFRESH_TOKEN_TTL_REMEMBER = 30 * 24 * 60 * 60;

export function defaultAccessTokenTtl(rememberMe: boolean): number {
  return rememberMe ? ACCESS_TOKEN_TTL_REMEMBER : ACCESS_TOKEN_TTL_DEFAULT;
}

export function defaultRefreshTokenTtl(rememberMe: boolean): number {
  return rememberMe ? REFRESH_TOKEN_TTL_REMEMBER : REFRESH_TOKEN_TTL_DEFAULT;
}
